<template>
	<div class="tabs-wrapper">
		<div class="tabs">
			<RouterLink
				v-for="tab of tabs"
				:key="tab.name"
				:to="{ name: tab.name }"
				custom
				v-slot="{ href, navigate, isActive, isExactActive }"
			>
				<a
					:href="href"
					class="tab"
					:class="{ 'is-active': inclusiveActive ? isActive : isExactActive }"
					@click="navigate"
				>
					{{ tab.label ?? tab.name }}
				</a>
			</RouterLink>
		</div>
	</div>
</template>

<script setup lang="ts">
import type { NavTab } from "@/models/NavTab";

withDefaults(
	defineProps<{
		tabs: NavTab[];
		inclusiveActive?: boolean;
	}>(),
	{
		inclusiveActive: false,
	},
);
</script>

<style lang="scss">
.tabs-wrapper {
	overflow: auto;
	flex: 0 0 max-content;
	padding: 0 1.5rem;
}

.tabs {
	list-style-type: none;
	white-space: nowrap;
	position: relative;
	display: inline-flex;
	min-width: 100%;

	@media screen and (max-width: var(--mobile-size)) {
		padding: 0 12px;
	}

	a.tab {
		padding: 9px 14px;
		color: var(--text-primary);
		cursor: pointer;
		text-decoration: none;
		display: inline-block;
		user-select: none;
		position: relative;
		padding-bottom: 9px + 2px;
		font-weight: 600;
		font-size: 0.85rem;

		&::after {
			position: absolute;
			content: "";
			height: 2px;
			width: 100%;
			bottom: 0px;
			left: 0px;
			z-index: 2;
			border-radius: var(--border-radius);
		}

		&:not(:first-child) {
			margin-left: 8px;
		}

		&.is-active {
			color: var(--accent-primary);

			&::after {
				background: var(--accent-primary);
			}
		}

		&:hover:not(.is-active) {
			color: var(--text-muted-hover);

			&::after {
				background: var(--text-muted-hover);
			}
		}
	}
}
</style>
